import React from "react"

import { Clock, Home } from "lucide-react"
import { Link } from "react-router-dom"

import AppLayout from "@/components/layout/AppLayout"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { SUPPORT_EMAIL } from "@/constants/contact"

const PendingPage = () => {
  return (
    <AppLayout>
      <div className="container mx-auto max-w-lg px-4 py-6">
        <Card>
          <CardHeader className="text-center">
            <div className="mb-4 flex justify-center">
              <div className="rounded-full bg-amber-100 p-3">
                <Clock className="h-8 w-8 text-amber-600" />
              </div>
            </div>
            <CardTitle className="text-xl font-bold text-jungle">
              Application Pending Review
            </CardTitle>
          </CardHeader>

          <CardContent className="space-y-4">
            <div className="rounded-lg border border-amber-200 bg-amber-50 p-4">
              <p className="mb-2 font-medium text-amber-800">Your application is pending review</p>
              <p className="text-sm text-amber-700">
                You are already active with another employer. Our staff needs to review your
                applications before you can continue. You should expect to be contacted by staff who
                will determine whether you can continue with your application.
              </p>
            </div>

            <div className="space-y-3">
              <h3 className="font-medium text-gray-900">What happens next?</h3>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start">
                  <span className="mr-3 mt-1.5 inline-block h-2 w-2 flex-shrink-0 rounded-full bg-amber-500"></span>
                  Our staff will review your application status
                </li>
                <li className="flex items-start">
                  <span className="mr-3 mt-1.5 inline-block h-2 w-2 flex-shrink-0 rounded-full bg-amber-500"></span>
                  You'll be contacted by our team regarding your application
                </li>
                <li className="flex items-start">
                  <span className="mr-3 mt-1.5 inline-block h-2 w-2 flex-shrink-0 rounded-full bg-amber-500"></span>
                  Staff will determine if you can continue with your application
                </li>
              </ul>
            </div>

            <div className="rounded-lg bg-gray-50 p-4">
              <p className="text-sm text-gray-600">
                If you have questions about your application status, please contact us at{" "}
                <a href={`mailto:${SUPPORT_EMAIL}`} className="text-honeycomb hover:underline">
                  {SUPPORT_EMAIL}
                </a>
              </p>
            </div>
          </CardContent>

          <div className="space-y-3 p-6 pt-0">
            <Link to="/application-status" className="block w-full">
              <Button variant="outline" className="w-full">
                Check Application Status
              </Button>
            </Link>
            <Link to="/" className="block w-full">
              <Button className="w-full bg-honeycomb hover:bg-amber-500">
                <Home className="mr-2 h-4 w-4" /> Return to Home
              </Button>
            </Link>
          </div>
        </Card>
      </div>
    </AppLayout>
  )
}

export default PendingPage
